<template>
    <div class="age" :class="{'error': ageError}">
        <span class="age__label">Wiek:</span>
        <div class="age__items">
            <div 
                v-for="a in ageRange" 
                :key="a" 
                class="age__item"
            >                
                <span 
                    class="age__circle" 
                    :class="{'age__circle--active': a === age}"
                    @click="changeAge(a)"
                >
                    {{ a }}
                </span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ProfileNewAge",
    props: {
        data: {
            type: Number,
            required: true
        },
        ageError: {
            type: Boolean
        }
    },
    data() {
        return {
            age: 0,
            ageRange: [3, 4, 5, 6, 7, 8, 9, 10]
        }
    },
    methods: {
        changeAge(a) {
            this.age = a;
            // this.subAccountCreate(a);
            this.$emit('setAge', a);
        }
    },
    mounted() {
        if(this.data) {
            this.age = this.data;
        }
    }
};
</script>